import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, Link } from 'react-router-dom';
import './BrandStatsHub.css';
import logo from '../image/LOGOTASKOPOS.jpg';

const BrandStatsHub = () => {
  const navigate = useNavigate();
  const user = useSelector((state) => state.AuthReducer?.user);

  // Redirection de sécurité si non admin
  React.useEffect(() => {
    if (user && user.role !== 'admin' && user.role !== 'useradmin') {
      navigate('/Valises');
    }
  }, [user, navigate]);

  const brands = [
    {
      id: 'bng',
      name: "BAG'N GO (BNG)",
      theme: 'bng',
      icon: '🧳',
      accentColor: '#059669',
      gradient: 'linear-gradient(135deg, #059669 0%, #00875a 100%)',
      lightBg: '#ecfdf5',
      borderColor: '#a7f3d0',
      description: 'Ventes valises, accessoires, emballage et caisses.',
      statsPath: '/Statistiques/Bagngo',
      statsLabel: "📊 Stats Bag'N Go",
      quickPath: '/CaisseMobile?locationName=BNG',
      quickLabel: "🛒 Caisse BNG",
      badgeText: 'Bagagerie'
    },
    {
      id: 'twinpark',
      name: 'TWIN PARK',
      theme: 'twinpark',
      icon: '🎡',
      accentColor: '#ef4444',
      gradient: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
      lightBg: '#fef2f2',
      borderColor: '#fecaca',
      description: 'Parcs Manar, Azur, Sousse, Bizerte et billetterie.',
      statsPath: '/Statistiques/Twinpark',
      statsLabel: '📊 Stats Twin Park',
      quickPath: '/ListeRapportsTwin',
      quickLabel: '📋 Rapports Twin',
      badgeText: 'Parcs'
    },
    {
      id: 'espace',
      name: 'E-SPACE',
      theme: 'espace',
      icon: '🛍️',
      accentColor: '#2563eb',
      gradient: 'linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)',
      lightBg: '#eff6ff',
      borderColor: '#bfdbfe',
      description: 'Boutiques Tunisia Mall, galeries et articles dérivés.',
      statsPath: '/Statistiques/Espace',
      statsLabel: '📊 Stats E-Space',
      quickPath: '/CaisseMobile?locationName=E-Space',
      quickLabel: '🛒 Caisse E-Space',
      badgeText: 'Boutiques'
    },
    {
      id: 'spintoss',
      name: 'SPINTOSS',
      theme: 'spintoss',
      icon: '🎯',
      accentColor: '#8b5cf6',
      gradient: 'linear-gradient(135deg, #8b5cf6 0%, #6d28d9 100%)',
      lightBg: '#f5f3ff',
      borderColor: '#ddd6fe',
      description: 'Jeux interactifs, tickets et rapports d’activité.',
      statsPath: '/Statistiques/Spintoss',
      statsLabel: '📊 Stats Spintoss',
      quickPath: '/ListRapportsSpintoss',
      quickLabel: '📋 Rapports Spintoss',
      badgeText: 'Jeux'
    },
    {
      id: 'wellness',
      name: 'WELLNESS & CARE',
      theme: 'wellness',
      icon: '🌿',
      accentColor: '#0d9488',
      gradient: 'linear-gradient(135deg, #0d9488 0%, #0f766e 100%)',
      lightBg: '#f0fdfa',
      borderColor: '#99f6e4',
      description: 'Soins, abonnements bien-être et prestations.',
      statsPath: '/Statistiques/Wellness',
      statsLabel: '📊 Stats Wellness',
      quickPath: '/ListRapport',
      quickLabel: '📋 Rapports Wellness',
      badgeText: 'Soins & Bien-être'
    },
    {
      id: 'achats',
      name: 'ACHATS & DÉPENSES',
      theme: 'achats',
      icon: '📦',
      accentColor: '#f59e0b',
      gradient: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
      lightBg: '#fffbeb',
      borderColor: '#fde68a',
      description: 'Achats fournisseurs, factures et réapprovisionnements.',
      statsPath: '/Statistiques/Achats',
      statsLabel: '📊 Stats Achats',
      quickPath: '/InvoiceDocList',
      quickLabel: '📑 Factures Fournisseurs',
      badgeText: 'Approvisionnements'
    }
  ];

  return (
    <div className="brand-hub-container single-screen-hub">
      {/* ══ HEADER COMPACT SANS SCROLL ══ */}
      <header className="brand-hub-header compact-header">
        <div className="hub-header-left">
          <img src={logo} alt="TASKO POS" className="hub-logo-sm" />
          <div>
            <div className="hub-title-row">
              <h1 className="hub-title-sm">Statistiques par Enseigne</h1>
              <span className="hub-admin-badge-sm">⭐ Admin</span>
            </div>
            <p className="hub-subtitle-sm">
              Consultez les performances, chiffres d'affaires et rapports en un clic.
            </p>
          </div>
        </div>

        <div className="hub-header-right">
          <Link to="/Home" className="hub-btn-sm hub-btn-home">
            💼 Menu Général
          </Link>
          <Link to="/AdvancedAnalytics" className="hub-btn-sm hub-btn-consolidated">
            🌐 Vue Consolidée
          </Link>
        </div>
      </header>

      {/* ══ GRILLE 3x2 PLEINE LARGEUR & COMPACTE SANS SCROLL ══ */}
      <section className="brand-hub-section compact-grid-section">
        <div className="brand-cards-grid-compact">
          {brands.map((brand) => (
            <div 
              key={brand.id} 
              className={`brand-card-compact brand-card-${brand.theme}`}
              style={{
                '--brand-color': brand.accentColor,
                '--brand-gradient': brand.gradient,
                '--brand-light-bg': brand.lightBg,
                '--brand-border': brand.borderColor,
              }}
            >
              <div className="brand-card-compact-head">
                <div className="brand-icon-sm" style={{ background: brand.lightBg }}>
                  <span>{brand.icon}</span>
                </div>
                <div className="brand-title-wrap">
                  <h2 className="brand-name-sm">{brand.name}</h2>
                  <span className="brand-badge-sm" style={{ background: brand.lightBg, color: brand.accentColor, borderColor: brand.borderColor }}>
                    {brand.badgeText}
                  </span>
                </div>
              </div>

              <p className="brand-desc-sm">{brand.description}</p>

              <div className="brand-actions-compact">
                <button
                  type="button"
                  onClick={() => navigate(brand.statsPath)}
                  className="brand-btn-compact-primary"
                  style={{ background: brand.gradient }}
                >
                  {brand.statsLabel}
                </button>

                <button
                  type="button"
                  onClick={() => navigate(brand.quickPath)}
                  className="brand-btn-compact-secondary"
                >
                  {brand.quickLabel}
                </button>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* ══ BANDEAU BAS COMPACT ══ */}
      <footer className="brand-hub-shortcuts-compact">
        <div className="shortcuts-strip">
          <span className="shortcuts-tag">⚡ Accès Rapides :</span>
          <div className="shortcuts-links">
            <Link to="/GestionRemises" className="shortcut-chip">🏷️ Remises</Link>
            <Link to="/GestionCaissiers" className="shortcut-chip">👤 Caissiers & PIN</Link>
            <Link to="/GestionEmplacements" className="shortcut-chip">📍 Emplacements</Link>
            <Link to="/HR/dashboard" className="shortcut-chip">📋 Espace RH</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default BrandStatsHub;
